import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import KycForm from '../../components/kyc/KycForm';
import { triggerKycPost } from './action';
import { resellers } from '../../constants/questions';

const mapStateToProps = (state: any) => {
    const { loading } = state;
    return {
        loading,
        questions: resellers,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return bindActionCreators({ onSubmit: triggerKycPost }, dispatch);
};

interface IDispatchToProps {
    onSubmit: (formData: any) => void;
}

const ConnectedCreateAdminRoles = connect<any, IDispatchToProps, void>(mapStateToProps, mapDispatchToProps)(KycForm);

export default ConnectedCreateAdminRoles;
